// @flow
import React from "react"
import { isNil } from "ramda"
import type { HOC } from "recompose"
import withQuery from "hoc/withQuery"
import urls from "data/router/urls"
import { reservationCountQuery } from "data/reservations/graphql/queries"
import { ReservationLinkWrap } from "./styled"

const ReservationsLink = ({ data }) => (
  <ReservationLinkWrap to={urls.reservations}>
    reservations&nbsp;{isNil(data) ? "" : `(${data})`}
  </ReservationLinkWrap>
)

const enhancer: HOC<*, {}> = withQuery(reservationCountQuery, {
  noEmpty: true,
  noLoader: true,
})

export default enhancer(ReservationsLink)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/DesktopLoggedInNav/ReservationsLink/index.js